/* eslint-disable @typescript-eslint/no-explicit-any */
import whenDomReady from 'when-dom-ready';
const API_URL = '/api/partner/projects/';
function initialise() {
    const loadMoreButton = document.querySelector('.js-projects-load-more');
    if (!loadMoreButton) {
        return;
    }
    loadMoreButton.addEventListener('click', function () {
        getData();
    });
    getData();
}
async function getData() {
    const projectsContainer = document.querySelector('.js-projects');
    const loadMoreButton = document.querySelector('.js-projects-load-more');
    if (!projectsContainer || !loadMoreButton) {
        return;
    }
    const pageIndex = loadMoreButton.getAttribute('data-page-index');
    const partner = loadMoreButton.getAttribute('data-partner');
    const res = await fetch(`${API_URL}/${partner}/${pageIndex}`);
    if (!res.ok) {
        return;
    }
    const resData = await res.json();
    projectsContainer.innerHTML = '';
    if (loadMoreButton && pageIndex) {
        loadMoreButton.setAttribute('data-page-index', (parseInt(pageIndex, 10) + 1).toString());
        resData.partnerProjects.map((item) => (projectsContainer.innerHTML += formatView(item)));
        loadMoreButton.style.visibility = resData.showLoadMore ? 'visible' : 'hidden';
    }
}
function formatView(item) {
    const url = item.linkUrl ? new URL(item.linkUrl) : null;
    const template = `<div class="grid-column">
  ${item.linkUrl
        ? ` <a href="${item.linkUrl}" class="project-card project-card--partner" target="_blank" rel="nofollow">`
        : ` <div class="project-card project-card--partner">`}
  <div class="project-card__inner">
  ${item.imageUrl
        ? `<div class="project-card__media">
                  <div class="project-card__media-holder">
                      <img class="project-card__media-element" loading="lazy" src="${item.imageUrl}" alt="" />
                  </div>
              </div>`
        : ``}
  ${item.genericStrings &&
        'award' in item.genericStrings &&
        item.genericStrings['award'] != null &&
        item.genericStrings['award'] != undefined &&
        item.genericStrings['award'] != ''
        ? `<div class="project-card__middle-band">
                  <div class="project-card__middle-content">
                      <div class="kentico-circle-icon">
                          <div class="icon-circle">
                              <svg class="icon-svg icon-kentico" viewBox="0 0 24 24">
                                  <use xlink:href="/src/img/svg/icon-kentico.svg#icon-kentico"></use>
                              </svg>
                          </div>
                      </div>
                      <p><span class="bullet">•</span> <span>${item.genericStrings['award']}</span></p>
                  </div>
              </div>`
        : ``}
  <div class="project-card__content-external">
              <div class="project-card__content-internal">
  ${item.title ? `<h4 class="project-card__title">${item.title}</h4>` : ``}
  ${item.summary && item.summary != undefined
        ? `<p class="project-card__intro">
                          ${item.summary}
                      </p>`
        : ``}
  ${url
        ? `<p class="fake-link fake-link--external">
                          ${url.host}
                          <svg class="icon-svg icon-diagonal-arrow" viewbox="0 0 24 24">
                              <use xlink:href="/src/img/svg/icon-diagonal-arrow.svg#icon-diagonal-arrow" />
                          </svg>
                      </p>`
        : ``}
  ${item.prettyDate && item.prettyDate != undefined
        ? ` <p class="card__event-date">${item.prettyDate}</p>`
        : ``}
  </div>
          </div>
      </div>
  ${item.linkUrl ? `</a>` : `</div>`}
  </div>`;
    return template;
}
whenDomReady().then(initialise);
